module.exports = "/assets/data/812d4875b0bc9c48dd833559cf08ec5f-CB9.data.json";